import React from 'react';
import Box from '@material-ui/core/Box';
import { Link } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Typography from '@material-ui/core/Typography';
import { HashRouter as Router } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Menu, MenuItem, FormControl, Select, } from '@mui/material';
import { connect } from 'react-redux';

// core components
import routes from '../routes.js';
import { getWorkspacePath } from '../utils/workspaceUtils.js';

class TitleBar extends React.Component {
    constructor(props) {
        super(props);
        // Filter out workspace-prefixed routes to avoid duplicates
        const baseRoutes = routes.filter(route => !route.workspacePrefixed);
        this.state = {
            routesState: baseRoutes,
            optionsDealsOffers: [], // ✅ this now uses the array you defined
            searchStatusDetails: "",
            openStatusDetails: false,
            selectedStatusDetails: "",
        };
    }
    componentDidMount() {

        let role = localStorage.getItem('role');
        // Filter out workspace-prefixed routes to avoid duplicates
        const baseRoutes = routes.filter(route => !route.workspacePrefixed);
        if (role == 'agent') {
            let remove = ['Campaign', 'Accounts', 'Users'];
            let routesAfter = baseRoutes.filter(({ name }) => !remove.includes(name));
            this.setState({ routesState: routesAfter });
        }
        this.setState({ optionsDealsOffers: baseRoutes.filter(({ navigation }) => navigation) });
    }

    // Helper function to get the display name for a route (handles Admin Panel/Agency Portal logic)
    getRouteDisplayName = (route) => {
        if (!route) return '';
        
        // Check if it's the admin panel route and user has agency subscription
        if (route.path === '/admin') {
            const { currentWorkspace } = this.props;
            const isAgency = currentWorkspace?.['currentSubscription']?.['planId']?.['planType'] === 'agency';
            return isAgency ? 'Agency Portal' : route.name;
        }
        return route.name;
    }

    getBrandText = path => {
        for (let i = 0; i < routes.length; i++)
            if (this['props']['location']['pathname'].indexOf(routes[i]['path']) !== -1) {
                return this.getRouteDisplayName(routes[i]);
            }
        return 'Brand';
    };

    activeRoute(routeName) {
        if (!this.props.location) return false;
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    }

    handleSelectStatusDetails = (value) => this.setState({ selectedStatusDetails: value, openStatusDetails: false });
    getFilteredOptionsStatusDetails = () => {
        const baseRoutes = routes.filter(route => !route.workspacePrefixed);
        this.setState({ optionsDealsOffers: baseRoutes.filter((status) => status['label'].toLowerCase().includes(this.state.searchStatusDetails.toLowerCase())) });
    }
    getActiveRouteName() {
        const active = routes.find((route) => this.activeRoute(route.path));
        return this.getRouteDisplayName(active);
    }

    render() {
        const { } = this['state'];
        const { end, } = this['props'];
        const { openStatusDetails, selectedStatusDetails, searchStatusDetails } = this.state;
        return (
            <div className='page-header-new style-heading'>
                <h2>
                    {/* Original route name mapping */}
                    <div className='filter-box'>
                        <FormControl fullWidth>
                            <div className='heading-dropdown-area'>
                                {/* {routes.map((route) => this.activeRoute(route['path']) ? route['name'] : '')} */}
                                <Select
                                    displayEmpty
                                    id='header-dropdown'
                                    open={openStatusDetails}
                                    className='header-dropdown'
                                    value={this.getActiveRouteName()}
                                    onOpen={() => this.setState({ openStatusDetails: true })}
                                    onClose={() => this.setState({ openStatusDetails: false })}
                                    onChange={(e) => this.handleSelectStatusDetails(e.target.value)}
                                    IconComponent={ExpandMoreIcon}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            // Handle the case when no value is selected but we need to show the active route
                                            return <em>{routes.map((route) => {
                                                if (this.activeRoute(route['path'])) {
                                                    return this.getRouteDisplayName(route);
                                                }
                                                return '';
                                            })}</em>;
                                        }
                                        
                                        // Find the option - need to handle both "Admin Panel" and "Agency Portal" for the admin route
                                        const selectedOption = this.state.optionsDealsOffers.find(option => {
                                            if (option.path === '/admin') {
                                                // For admin route, match either "Admin Panel" or "Agency Portal"
                                                return selected === 'Admin Panel' || selected === 'Agency Portal';
                                            }
                                            return option.name === selected;
                                        });
                                        
                                        if (selectedOption) {
                                            const displayName = this.getRouteDisplayName(selectedOption);
                                            return (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    {/* <i style={{ marginRight: "10px" }}>{selectedOption.icon}</i> */}
                                                    <h2>{displayName}</h2>
                                                </Box>
                                            );
                                        }
                                        return selected;
                                    }}
                                    MenuProps={{ disableAutoFocusItem: true, PaperProps: { className: 'header-dropdown-menu' } }}
                                >
                                    {/* <MenuItem disableRipple>
                                        <TextField
                                            fullWidth
                                            autoFocus
                                            variant="standard"
                                            placeholder="Search..."
                                            value={searchStatusDetails}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => this.setState({ searchStatusDetails: e['target']['value'] })}
                                        />
                                        <button className='search-icon'>
                                            <i className='icon'>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_224_579)">
                                                        <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_224_579">
                                                            <rect width="18" height="18" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </i>
                                        </button>
                                    </MenuItem> */}

                                    {this.state.optionsDealsOffers.length > 0 ? (
                                        this.state.optionsDealsOffers.map((status) => {
                                            const displayName = this.getRouteDisplayName(status);
                                            return (
                                                <MenuItem
                                                    key={status.name}
                                                    value={displayName}
                                                    onClick={() => {
                                                        const workspacePath = getWorkspacePath(status.path, this.props.currentWorkspace?._id);
                                                        this.props.history.push(workspacePath); // 🔄 programmatic route change
                                                        this.setState({ openStatusDetails: false });
                                                    }}
                                                >
                                                    <i style={{ marginRight: "10px" }}>{status.icon}</i> {displayName}
                                                </MenuItem>
                                            );
                                        })
                                    ) : <MenuItem disabled>No results found</MenuItem>}
                                </Select>
                            </div>
                        </FormControl>
                    </div>
                </h2>
            </div>
        );
    }
}
const mapStateToProps = ({ Settings: { currentWorkspace } }) => ({ currentWorkspace });
export default connect(mapStateToProps)(withRouter(TitleBar));